import { motion, useReducedMotion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 26, className = '', ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-brand-skyDeep">
    <span className="h-1.5 w-1.5 rounded-full bg-brand-honey" aria-hidden="true" />
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, sub, center = false }) => (
  <div className={center ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
    <Reveal>
      <Eyebrow>{eyebrow}</Eyebrow>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 text-2xl font-bold tracking-tight text-brand-navy sm:text-3xl lg:text-4xl">
        {title}
      </h2>
    </Reveal>
    {sub ? (
      <Reveal delay={0.16}>
        <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">{sub}</p>
      </Reveal>
    ) : null}
  </div>
);
